import { Injectable, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable()
export class LoaderService {

  constructor(

  ) {
  }

  private fooSubject = new Subject<any>();

  showLoader() {
    this.publishEvent(LoaderEvents.SHOW_LOADER);
  }

  hideLoader() {
    this.publishEvent(LoaderEvents.HIDE_LOADER);
  }

  private publishEvent(event: keyof typeof LoaderEvents) {
    this.fooSubject.next(event);
  }

  getObservable(): Subject<any> {
    return this.fooSubject;
  }
}

export enum LoaderEvents {
  SHOW_LOADER = 'SHOW_LOADER',
  HIDE_LOADER = 'HIDE_LOADER'
}
